// API Configuration for Sports Booking System
// In production, API calls go through the same domain (proxied by nginx)
// In development, API calls go to localhost:4000

const getApiBaseUrl = () => {
  // In production build, use relative URLs (nginx will proxy to backend)
  if (process.env.NODE_ENV === 'production') {
    return '';  // Empty string = same origin, nginx proxies /api to backend
  }
  // In development, use localhost
  return process.env.REACT_APP_API_URL || 'http://localhost:4000';
};

export const API_BASE_URL = getApiBaseUrl();
export const API_URL = `${API_BASE_URL}/api`;

export default API_BASE_URL;
